declare namespace $ {

	type $mol_view__sub_bog_bzrl_app_step_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_bzrl_app_step_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_bzrl_app_step_3 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_step['title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_bzrl_app_step_4 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_step['description'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	export class $bog_bzrl_app_step extends $mol_view {
		number( ): number
		Number( ): $mol_view
		icon( ): any
		Icon( ): $mol_view
		title( ): string
		Title( ): $mol_paragraph
		description( ): string
		Description( ): $mol_paragraph
		sub( ): readonly(any)[]
	}
	
	export class $bog_bzrl_app_step_match extends $bog_bzrl_app_step {
		Icon_match( ): $mol_icon_magnify
		number( ): number
		icon( ): ReturnType< $bog_bzrl_app_step_match['Icon_match'] >
		title( ): string
		description( ): string
	}
	
	export class $bog_bzrl_app_step_request extends $bog_bzrl_app_step {
		Icon_request( ): $mol_icon_email_outline
		number( ): number
		icon( ): ReturnType< $bog_bzrl_app_step_request['Icon_request'] >
		title( ): string
		description( ): string
	}
	
	export class $bog_bzrl_app_step_pay extends $bog_bzrl_app_step {
		Icon_pay( ): $mol_icon_currency_rub
		number( ): number
		icon( ): ReturnType< $bog_bzrl_app_step_pay['Icon_pay'] >
		title( ): string
		description( ): string
	}
	
}

//# sourceMappingURL=step.view.tree.d.ts.map